<template>
  <div class="page-activity" :class="{'mobile': _isMobile}">
    <div class="activity-wrap " :class="{'pc': !_isMobile}">
      <cmpBanner bannerType="12"></cmpBanner>

      <div class="g-wrap">
        <!-- <cmpTab :tabs="tabList" :activeVal="activeVal" :subHeight="'760px'" @eventTabClick="eventTabClick"></cmpTab> -->

        <div class="g-content">
          <el-row class="list g-card-list" :gutter="_isMobile?10:20">
            <el-col class="item g-card-1" :span="_isMobile?12:8" v-for="(item, index) in dataList" :key="index">
              <div @click="goDetail(item)">
                <div class="pic-box pic1">
                  <img v-lazy="item.picture" alt="">
                </div>
                <div class="info">
                  <h2 class="title ell m-font-3">{{item.name}}</h2>
                  <!-- <p class="time m-font-4">{{item.publishTime}}</p>
                  <p class="m-font-3 ell">{{item.position}} </p>
                  <img class="status" src="~@images/status-1.png" alt="" v-if="item.status==2">
                  <img class="status" src="~@images/status-2.png" alt="" v-if="item.status==3"> -->
                </div>
              </div>
            </el-col>

            <!-- 无数据 -->
            <div class="g-no-data" v-if="dataList.length === 0 && !listLoading">
              <div class="no-data-bg"></div>
              <p class="txt text-center">暂无数据</p>
            </div>
          </el-row>

          <cmpMyPagination :currentPage="listQuery.page" :pageSize="listQuery.size" :total="total" @eventPage="eventPage"></cmpMyPagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '@assets/css-mobile/product/index.scss'
export default {
  watch: {
    $route(to, from) {
      this.activeVal = this.$route.query.pageType || '1'

      this.listQuery.page = 1
      this.getDataList()
    }
  },
  data() {
    return {
      activeVal: this.$route.query.pageType || '1',
      tabList: [
        {
          name: '社教活动',
          val: '1'
        },
        {
          name: '游学活动',
          val: '2'
        },
        {
          name: '讲座',
          val: '3'
        },
        {
          name: '手工',
          val: '4'
        },
        {
          name: '其他',
          val: '5'
        }
      ],
      dataList: [],
      listQuery: {
        page: 1,
        size: 9,
      },
      total: '0',
      listLoading: false,
    }
  },
  methods: {
    getDataList() {

      this.listLoading = true
      this.$http
        .get('/webapi/culturalcreative/list', {
          ...this.listQuery,
          type: this.activeVal
        })
        .then(res => {
          this.listLoading = false
          if (res.success) {
            let data = res.data
            this.dataList = data.records
            this.total = data.total
          } else {
            this.$message.error(res.message)
          }
        }).catch(err => {
        })
    },
    eventTabClick(val) {
      this.activeVal = val
      this.listQuery.page = 1
      this.getDataList()
    },
    eventPage(obj) {
      this.listQuery.page = obj.page
      this.listQuery.size = obj.size
      this.getDataList()
    },
    goDetail(item) {
      console.log(item)
      this.$router.push({
        path: '/product/detail',
        query: {id: item.id}
      })
    },
  },
  created() {
    this.getDataList()
  }
}
</script>

<style lang="scss" scoped>
.activity-wrap {
  font-size: 20px;
  .list {
    .item {
      .pic-box {
        // background: #FAFAFA;
        padding: 20px;
        height: 256px;
        box-sizing: border-box ;
        img {
          height: 100%;
        }
      }
      .status {
        width: 92px;
        // height: 84px;
        position: absolute;
        right: 20px;
        bottom: 20px;
      }
      .info {
        padding: 20px 30px;
        height: auto;
        background: #fff;
        h2 {
          margin-bottom: 0;
          color: #0E0E0E;
          text-align: center;
        }
      }
    }
  }
}
</style>


